/**
 * @generated SignedSource<<ac82c9b685848fe9447adf7c5b2d97a0>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateCompanyPayload",
            "kind": "LinkedField",
            "name": "updateCurrentCompany",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfCompany",
                    "kind": "LinkedField",
                    "name": "companyEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Company",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "administrationEmail",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditCompanySettingsModal_updateMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditCompanySettingsModal_updateMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "1f8dc4596fd990c5bee4fa047d61d4af",
            "id": null,
            "metadata": {},
            "name": "EditCompanySettingsModal_updateMutation",
            "operationKind": "mutation",
            "text": "mutation EditCompanySettingsModal_updateMutation(\n  $model: UpdateCurrentCompanyRequestInput!\n) {\n  updateCurrentCompany(model: $model) {\n    companyEdge {\n      node {\n        id\n        name\n        administrationEmail\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "6d3ccf0239d76baf4cba79b23faf0576";
export default node;
